module.exports = __webpack_public_path__ + "img/crashLog.93ffadc3.png";